let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1VOG0")).then(() => parcelRequire('d0DRA'));